import { BrandColors, Colors } from "@/constants/theme";
import Ionicons from "@react-native-vector-icons/ionicons";
import {
    StyleSheet,
    TouchableOpacity,
    useColorScheme,
    View,
} from "react-native";
import { ThemedText } from "../themed-text";

interface TagSectionProps {
  title: string;
  items: string[];
  onEdit?: () => void;
}

const TagSection = ({ title, items, onEdit }: TagSectionProps) => {
  const colorScheme = useColorScheme();
  const theme = Colors[colorScheme ?? "light"];

  return (
    <View style={styles.section}>
      <View style={styles.cardHeader}>
        <ThemedText style={styles.cardTitle} type="defaultSemiBold">
          {title}
        </ThemedText>
        {onEdit ? (
          <TouchableOpacity onPress={onEdit} hitSlop={8} activeOpacity={0.7}>
            <Ionicons name="pencil" size={18} color={BrandColors.primary} />
          </TouchableOpacity>
        ) : null}
      </View>
      <View
        style={[
          styles.tagsCard,
          { borderColor: theme.border, backgroundColor: theme.background },
        ]}
      >
        <View style={styles.tagsWrap}>
          {items.map((label) => (
            <View key={label} style={[styles.tag, { borderColor: theme.border }]}>
              <Ionicons
                name="checkmark-circle"
                size={14}
                color={BrandColors.primary}
              />
              <ThemedText style={styles.tagText} type="extraSmall">
                {label}
              </ThemedText>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  section: {
    paddingHorizontal: 16,
    paddingTop: 20,
  },
  cardHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 12,
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: "700",
  },
  tagsCard: {
    borderRadius: 16,
    padding: 14,
    borderWidth: 1,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.04,
    shadowRadius: 8,
    elevation: 2,
  },
  tagsWrap: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  tag: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    borderWidth: 1,
    borderRadius: 20,
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  tagText: {
    fontWeight: "500",
  },
});

export default TagSection;
